export default {
  white: '#ffffff',
  black: '#000000',
  darkPurple: '#201547',
  purpleButtonText: '#201547bf',
  purpleButtonTextHover: '#201547e6',
  mediumPurple: '#797391',
  lightPurple: '#bcb7c7',
  lighterPurple: '#dfdae7',
  lightPurpleBackground: '#ece9f1',
  aqua: '#03b6bd',
  aquaDarker: '#009ea4',
  aquaBackground: '#ddf9f9',
  lightGreen: '#cfdd00',
  lightGreenBackground: '#f6fac2',
  error: '#af272f',
  errorBackground: '#fbeeef',
  grey: '#6f6f6f',
  lightGray: '#f2f2f2'
}
